export const BLACKLISTED_SHARE_CODES: string[] = [
  // General Navigation
  "home",
  "root",
  "dashboard",
  "profile",
  "settings",
  "preferences",
  "notifications",
  "notification",
  "search",
  "share",
  "shares",
  "view",
  "update",
  "maintenance",
  "no-internet",
  "status",
  "health",
  "healthcheck",
  "ping",

  // Booking
  "schedule",
  "book",
  "booking",
  "bookings",
  "appointment",
  "appointments",
  "calendar",
  "request",
  "requests",
  "reminder",
  "reminders",
  "report",
  "reports",
  "weekly-report",
  "weekly-reports",

  // Entities
  "dentist",
  "dentists",
  "clinic",
  "clinics",
  "patient",
  "patients",
  "service",
  "services",
  "user",
  "users",
  "account",
  "accounts",

  // Auth
  "auth",
  "authentication",
  "login",
  "log-in",
  "signin",
  "sign-in",
  "logout",
  "log-out",
  "signup",
  "sign-up",
  "register",
  "registration",
  "verify",
  "verification",
  "otp",
  "password",
  "forgot-password",
  "reset-password",
  "delete-account",

  // Marketing
  "help",
  "support",
  "contact",
  "contact-us",
  "about",
  "faq",
  "blog",
  "docs",
  "documentation",
  "guide",
  "guides",
  "press",
  "media",
  "careers",
  "jobs",
  "pricing",
  "plans",
  "paywall",
  "subscribe",
  "subscription",
  "billing",
  "payment",
  "payments",

  // Legal
  "privacy",
  "terms",
  "legal",
  "terms-of-service",
  "privacy-policy",

  // System
  "admin",
  "api",
  "v1",
  "v2",
  "static",
  "assets",
  "images",
  "img",
  "css",
  "js",
  "fonts",
  "favicon",
  "favicon.ico",
  "robots",
  "robots.txt",
  "sitemap",
  "sitemap.xml",
  "manifest",
  "manifest.json",
  "service-worker",
  "sw",
  "pwa",
  "offline",

  // Platform
  "app",
  "ios",
  "android",
  "web",

  // Short paths
  "s",
  "g",
];
